<template>
    <div class="saleBaseBox">
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" :before-close="dialogVisibleClose"
                   class="eldialog eldialogC no_print eldialogWidth" :modal="false" custom-class="full_dialog"
                   :title="getDialogTitle()" >
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogForm dialogFormB" :rules="saleorderA" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="客户名称：" prop="customer_id" class="selectCustomerNoDown">
                            <select-down-customer :disableinput="!saleOrderIsEdit" :salesman_id="form_params.salesman_id" :id="form_params.customer_id" ref="selectdowncustomer" @changeselect="res=>{form_params.customer_id = res;}"></select-down-customer>
                            <i class="el-input__icon el-icon-more" v-if="saleOrderIsEdit" @click="dialogVisibleCustomer=!dialogVisibleCustomer"></i>
                        </el-form-item>
                        <el-form-item  label="销售人：" prop="salesman_id">
                            <el-select  :disabled="!saleOrderIsEdit" v-model="form_params.salesman_id" @change="saleChange" @visible-change="getSelectList('user',$event)">
                                <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="付款方式：" prop="payment_type_id">
                            <el-select :disabled="!saleOrderIsEdit" v-model="form_params.payment_type_id" @visible-change="getSelectList('paymentType',$event)">
                                <el-option v-for="list in selectMap.paymentType" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="预计收汇：" prop="predict_time">
                            <el-date-picker :disabled="!saleOrderIsEdit" v-model="form_params.predict_time" type="date" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="销售日期：" prop="sales_time">
                            <el-date-picker :disabled="!saleOrderIsEdit" v-model="form_params.sales_time" type="date" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="发货日期：" prop="delivery_time">
                            <el-date-picker :disabled="!saleOrderIsEdit" v-model="form_params.delivery_time" type="date" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox elFormBoxBtnList elDialogElFormBoxCheckbox" v-if="sourceFrom!=='return'">
                        <img v-if="recIsEdit" src="/icon/operation_edits.png" @click="amend" class="form_edits">
                        <el-form-item label="REC：" class="REC_FORM_ITEM" >
                            <el-checkbox :disabled="!saleOrderIsEdit" class="taxCheck" v-model="form_params.rec"></el-checkbox>
                            <div class="taxDiv" v-if="form_params.rec">
                                <el-select :disabled="!saleOrderIsEdit" class="taxTypeSelect" placeholder="fx"
                                           v-model="form_params.rec_type">
                                    <el-option :value="1" label="×"></el-option>
                                    <el-option :value="2" label="÷"></el-option>
                                </el-select>
                                <el-input :disabled="!saleOrderIsEdit" class="taxInput" v-model="form_params.tax_rate"
                                          v-digits:2="form_params.tax_rate"
                                          placeholder="税率" ></el-input>
                                <span class="taxSpan">%</span>
                            </div>
                        </el-form-item>
                        <el-form-item  label="车牌：">
                            <el-input v-model="form_params.truck_remark" @change="changeTruck_remark()"></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox elDialogElFormBoxCheckbox" v-if="sourceFrom!=='return'">
                        <!-- <el-form-item label="税率%：" v-if="form_params.rec">
                            <el-input v-model="form_params.tax_rate"></el-input>
                        </el-form-item> -->
                        <el-form-item class="receivableRelationBox">
                            <div :class="saleOrderIsEdit? 'receivableRelation':'receivableRelationNoedit'" @click="getRelationReceivable">关联应收</div>
                            <div class="recrivableNumber">￥{{form_params.traffic_amount}}</div>
                        </el-form-item>
                        <el-form-item  label="锁货等级：" prop="order_lock_level_id" v-if="enableConfig.includes('LOCK_LEVEL')">
                            <el-select :disabled="!saleOrderIsEdit" v-model="form_params.order_lock_level_id" @visible-change="getSelectList('lockLevel',$event)">
                                <el-option v-for="list in selectMap.lockLevel" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item  label="折扣：" v-if="Number(discountSet)===1">
                            <el-checkbox v-model="form_params.is_discount_rate" ></el-checkbox>
                            <el-input v-model="form_params.discount_rate"
                                      v-if="form_params.is_discount_rate"
                                      v-digits:2="form_params.discount_rate"
                                      placeholder="折扣：" class="checkbox"></el-input>
                        </el-form-item> -->
                    </div>
                    <div class="globalSee" v-if="sourceFrom!=='return'&&form_params.id" @click="linkSeeReview"></div>
                    <div class="globalFilterBtn" v-if="module.includes(',system-column-set,')" @click="filterDialogVisible=!filterDialogVisible"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <!-- 修改 table START -->
                                <el-table :data="listDetail"  :row-class-name="tableRowClassName" :summary-method="getTableSummaries"  ref="listDetailTable" border stripe highlight-current-row show-summary size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection"
                                    @header-dragend="headDrog"
                                    >
                                    <el-table-column key="1" type="index" label="序号" align="center" width="50"></el-table-column>
                                    <el-table-column type="selection"  v-if="saleOrderIsEdit" :selectable="checkSelectable" width="50"></el-table-column>
                                    <el-table-column key="2" label="操作" width="75" v-if="saleOrderIsEdit">
                                        <template slot-scope="scope">
                                            <div class="icon_wrap">
                                                <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                                <i class="operation_delete" @click="listDetailDelete(scope.$index,scope.row)" title="删除"></i>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <template v-for="(item) in filters">
                                        <!-- 单价 / 立方 特殊处理 start -->
                                        <template v-if="item.field == 'sales_price' || item.field == 'sales_cube'||item.field == 'sales_breed'">
                                            <!-- :render-header="renderHeader" :column-key="index.toString()" -->
                                            <el-table-column :prop="item.field" v-if="item.show && billColumns.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                                <template slot="header" v-if="saleOrderIsEdit">
                                                    <template v-if="item.field == 'sales_price'">
                                                        <el-popover placement="bottom" title="" ref="sales_priceDialog" trigger="click" v-model="mutilDialogVisible.sales_price">
                                                            <span class="cont_span">单价</span>
                                                            <span class="pop_btn" size="mini" slot="reference">单价（<span class="cont_blue">批量</span>）</span>
                                                            <div class="batchInputBox">
                                                                <input :disabled="!saleOrderIsEdit" size="mini" v-model="mutil_params.sales_price" class="batchInput"
                                                                    @input="salesPriceInput($event)" @blur="salesPriceInput($event)" />
                                                            </div>
                                                            <div class="cont_top1 pop_title pop_Btn">
                                                                <el-button type="primary" plain size="mini" @click="batchChange">确定</el-button>
                                                            </div>
                                                        </el-popover>
                                                    </template>
                                                    <template v-if="item.field == 'sales_cube'">
                                                        <el-popover placement="bottom" title="" trigger="click" ref="sales_cubeDialog" v-model="mutilDialogVisible.sales_cube">
                                                            <span class="pop_btn" size="mini" slot="reference" @click="decimalGet()">立方<div class="salePercentage"></div>
                                                            <div @click.stop="withdraw" v-if="billColumns.includes('original_cube')" class="salePercentages"></div></span>
                                                            <div class="batchCube">
                                                                <span class="setIcon" v-if="module.includes(',setting-advanced-config-edit,')" @click="()=>decimalShow = true" title="设置小数点位数"><i class="el-icon-s-tools"></i></span>
                                                                <span class="cont_span">批量%立方</span>
                                                            </div>
                                                            <div class="batchInputBox  saleSel">
                                                                <input size="mini" id="ceshidom" :value="mutil_params.sales_cube_rate" class="batchInput"
                                                                    @input="salesCubeRateInput($event)" @blur="salesCubeRateInput($event)" placeholder="请输入立方百分比" />
                                                                    <select v-model="cube_id"
                                                                        class="batchInput fixed-height"
                                                                        style="width: 100%;height: 25px;" placeholder="请选择">
                                                                            <option :value="1" label="销售立方"></option>
                                                                            <option v-if="module.includes(',sale-original-cube-sel,')" :value="2" label="码单立方"></option>
                                                                            <option v-if="module.includes(',sale-original-cube-sel,')" :value="3" label="检尺立方"></option>
                                                                    </select>
                                                            </div>
                                                            <div class="popoverBackBox clearfix">
                                                                <span class="popoverBack" @click="recoverCube">恢复初始立方</span>
                                                                <img src="/icon/question.png" class="popoverBackImg"/>
                                                                <div class="popoverBackTip">注：销售单保存后无法恢复到初始立方，需要删除重新添加。</div>
                                                            </div>
                                                            <div class="cont_top1 pop_title pop_Btn">
                                                                <el-button class="popBtn" size="mini" @click="hideSalesCubeDialog">取消</el-button>
                                                                <el-button type="primary" plain size="mini" @click="salesCubeChange">确定</el-button>
                                                            </div>
                                                        </el-popover>
                                                    </template>
                                                    <template v-if="item.field == 'sales_breed'">
                                                            <span class="pop_btn" size="mini" slot="reference" @click="openBreed()">销售品名<div class="salePercentage"></div>
                                                           </span>
                                                    </template>
                                                </template>
                                                <template slot-scope="scope">
                                                    <template v-if="item.field == 'sales_price'">
                                                        <el-input v-if="scope.row.inventory_id" :disabled="!saleOrderIsEdit" @click.stop.native="stopstop" :class="[module.indexOf(',setting-advanced-sales-mini,')!=-1?'':Number(scope.row.sales_price)<Number(scope.row.min_price)?'warningMinPrice':'']"
                                                            v-model="scope.row.sales_price" @input="salesPrice($event)" @blur="salesWatch($event)"></el-input>
                                                    </template>
                                                    <template v-if="item.field == 'sales_cube'">
                                                        <el-input v-if="scope.row.inventory_id" :disabled="!saleOrderIsEdit||!(scope.row.sales_width_total=='0'||scope.row.sales_width_total=='')?true:false" @click.stop.native="stopstop" :class="[module.indexOf(',setting-advanced-sales-mini,')!=-1?'':Number(scope.row.sales_cube)<Number(scope.row.min_cube)?'warningMinPrice':'']"
                                                            v-model="scope.row.sales_cube" @input="salesCube($event)" @blur="salesWatch($event)"></el-input>
                                                    </template>
                                                    <template v-if="item.field == 'sales_breed'">
                                                        <el-input v-if="scope.row.inventory_id" :disabled="true"
                                                            v-model="scope.row.sales_breed" @input="salesCube($event)" @blur="salesWatch($event)"></el-input>
                                                    </template>
                                                </template>
                                            </el-table-column>
                                        </template>
                                        
                                        <!-- 单价特殊处理 end -->
                                        <template v-else>
                                            <!-- :render-header="renderHeader" :column-key="index.toString()" -->
                                            <el-table-column  :prop="item.field" v-if="item.show && billColumns.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >   
                                                <template  slot-scope="scope">
                                                    <!-- 特殊处理 START -->
                                                    <div v-if="item.field == 'bale_no'">
                                                        {{ scope.row.bale_no}}
                                                        <div class="sign" v-if="sourceFrom==='inventory' &&scope.row.inventory_id === form_params.saleInventory_id"></div>
                                                    </div>
                                                    <div v-else-if="item.field == 'thumbnail'">
                                                        <viewer :images="scope.row.images">
                                                            <img v-for="(src,index) in scope.row.images" v-show="index < 1" class="viewImg" :src="src" :key="index"/>
                                                        </viewer>
                                                    </div>
                                                    <div v-else-if="item.field == 'original_width_total'">
                                                        <span @click="widthList = scope.row.width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                            {{ scope.row.original_width_total }}
                                                        </span>
                                                    </div>
                                                    <div v-else-if="item.field == 'sales_width_total'">
                                                        <span @click="widthList = scope.row.sales_width;listType=scope.$index;dialogVisibleWidth=true;widthSaleInventoryId=scope.row.inventory_id;" style="text-decoration:underline;cursor:pointer;">
                                                            {{ scope.row.sales_width_total }}
                                                        </span>
                                                    </div>
                                                    <div v-else-if="item.field == 'files' && form_params.id">
                                                        <div @click.stop="relativeFileOpen(scope.row.files)">
                                                            <img src="/icon/associatedfiles.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;"/>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="item.field == 'breed'">
                                                        <span style="display: flex;">
                                                            {{ scope.row.breed }}
                                                            <el-tooltip class="item" effect="dark" content="移动端销售调货" placement="top">
                                                                <img v-if="scope.row.is_transfer==1" src="/icon/shunt.png" style="width:17px;height:15px;cursor:pointer;display:block;margin:auto;"/>
                                                            </el-tooltip>
                                                        </span>
                                                    </div>
                                                    <!-- 特殊处理 END -->
                                                    <span v-else>
                                                        {{ scope.row[item.field] }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </template>
                                </el-table>
                            <!-- 修改 table END -->
                        </div>
                    </div>
                    <div class="dialogTotal clearfix">
                        <div class="dialogTotalC">合计{{moneyTitle}}</div>
                        <div class="dialogTotalC" v-if="Number(tableTotal.sales_amount)">销售金额:{{tableTotal.sales_amount}}</div>
                        <div class="dialogTotalC" v-if="Number(tableTotal.discount_amount)">折扣金额:{{tableTotal.discount_amount}}</div>
                        <div class="dialogTotalC" v-if="Number(tableTotal.tax_amount)">税金:{{tableTotal.tax_amount}}</div>
                        <div class="dialogTotalC" v-if="Number(tableTotal.traffic_amount)">关联{{moneyTitle}}:{{tableTotal.traffic_amount}}</div>
                        <div class="dialogTotalC" v-if="Number(tableTotal.other_amount)">其它费用:{{tableTotal.other_amount}}</div>
                        <div class="dialogTotalC" v-if="Number(tableTotal.reduce_amount)">优惠:{{tableTotal.reduce_amount}}</div>
                        <div class="dialogTotalC" v-if="Number(tableTotal.receivable_amount)">{{moneyTitle}}金额:{{tableTotal.receivable_amount}}</div>
                    </div>
                    <div class="remarkBox">
                        <textarea :disabled="!saleOrderIsEdit" class="remarkTextarea" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                    <div class="editPayBox clearfix">
                        <el-form class="" :rules="saleorderB" :disabled="!saleOrderIsEdit" :model="form_params" ref="saleorderB">
                            <div class="editPay">
                                <el-form-item  label="收款账户：" prop="account_id">
                                    <el-select  v-model="form_params.account_id" @change="selectAccount" @visible-change="getSelectList('account',$event)">
                                        <el-option v-for="list in selectMap.account" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="editName">账号：{{form_params.bank_no}}</div>
                                <div class="editName">户名：{{form_params.account_name}}</div>
                                <div class="editName">开户行：{{form_params.bank_name}}</div>
                            </div>
                            <div class="editPay bottom_flex">
                                <div class="piaoMess clearfix" v-if="form_params.rec">
                                    <div class="piaoMessC">
                                        名称：{{bill.invoice_name}}<br/>
                                        开户行：{{bill.invoice_bank_name}}<br/>
                                        税号：{{bill.invoice_no}}
                                    </div>
                                    <div class="piaoMessC">
                                        账号：{{bill.invoice_bank_no}}<br/>
                                        地址：{{bill.invoice_addr}}<br/>
                                        电话：{{bill.invoice_phone}}
                                    </div>
                                </div>
                                <div class="clearfix">
                                    <el-form-item  label="首次付款：" v-if="sourceFrom!=='return'" prop="first_amount" style="margin-right:93px;float:left">
                                        <el-input v-digits:2="form_params.first_amount"
                                                  v-model="form_params.first_amount"></el-input>
                                    </el-form-item>
                                    <el-form-item label="优惠：" prop="reduce_amount" style="float:left;">
                                        <el-input v-model="form_params.reduce_amount" v-digits:2="form_params.reduce_amount"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <div class="editPerson">审核人：{{form_params.auditor_name}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="bottomBtn">
                    <slot></slot>
                </div>
            </div>
        </el-dialog>

        <!--选择库存START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleStock" class="eldialog eldialogStock" width="1350px" :modal="false" title="选择库存" custom-class="full_dialog">
            <sales-select ref="selectstock" @cancel="dialogVisibleStock=!dialogVisibleStock" @selectData="selectData" @selectAndOut="selectAndOut"></sales-select>
        </el-dialog>
        <!--选择库存END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" :scene="columnScene" :isGlobal="true" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!--选择客户START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleCustomer" class="eldialog eldialogStock" width="825px" :modal="false" title="选择客户" custom-class="full_dialog">
            <select-customer :saleman="form_params.salesman_id" @cancel="dialogVisibleCustomer=!dialogVisibleCustomer" @selectAndOut="selectAndOutCustomer"></select-customer>
        </el-dialog>
        <!--选择客户END-->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <!-- @returnwidth="res=>{this.listDetail[this.listType].sales_width=res;calculation(this.listType);}" -->
            <total-widthnew :edit="saleOrderIsEdit" :saleedit="true" :list="widthList" :issetper="true" :perval="1" :widthSaleInventoryId="widthSaleInventoryId"  :dialogvisible="dialogVisibleWidth" @saleChange="widthsaleChange" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 关联应收费用 START -->
        <fee-relation-sale :dialogVisibleRelation="dialogVisibleRelation" :relatedremark="form_params.related_remark"
                           :data="form_params.relate_list" :isEdit="saleOrderIsEdit" :hasRec="form_params.rec"
                           @confirm="res=>{this.relationObj = res;this.confirmRelative()}"
                           @closeDialog="()=>{this.dialogVisibleRelation = false;}"></fee-relation-sale>
        <!-- 关联应收费用 END -->
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>
        <!--REC START -->
        <el-dialog  v-dialog-drag title="税金修改" :visible.sync="recChanges"
                width="350px" class="eldialog" :model="false" custom-class="full_dialog">
            <el-form :model="rec_params" :inline="true" label-width="110px" class="demo-form-inline"
                size="mini">
                <el-form-item label="REC:" >
                    <el-checkbox class="taxCheck" v-model="f_rec" style="margin-right: 10px;"></el-checkbox>
                    <el-select class="formInput" style="width:60px" placeholder="fx" v-model="rec_params.rec_type">
                        <el-option :value="1" label="×"></el-option>
                        <el-option :value="2" label="÷"></el-option>
                    </el-select>
                    <el-input v-model="rec_params.tax_rate"  style="width:90px;" v-digits:2="rec_params.tax_rate" class="formInput tax_rate">
                    </el-input>
                    <span style="position: absolute;right: 5px;">%</span>
                </el-form-item>
                <el-form-item label="税金金额:" >
                    <el-input class="formInput" v-model="rec_params.recTax_amount" readonly></el-input>
                </el-form-item>
                <el-form-item label="备注:">
                    <textarea style="width: 180px;min-height: 60px;" class="edit_input edit_textarea formInput" v-model="rec_params.remark">
                    </textarea>
                </el-form-item>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="settlementConfirm">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="outRecChanges()">取消</el-button>
            </div>
        </el-dialog>
        <!--REC END -->
        <!--品名修改弹框 START -->
        <el-dialog  v-dialog-drag title="修改销售品名" :visible.sync="breedChanges" :before-close="closeBreed"
                width="350px" class="eldialog" :model="false" custom-class="full_dialog">
            <div style="padding: 20px;">
                <el-select v-model="sales_breedData" @change='changeBreedSplit()' @visible-change="getSelectList('saleBreed',$event)">
                    <el-option v-for="list in selectMap.saleBreed" :key="list.id" :value="list.id+'+'+list.name" :label="list.name"></el-option>
                </el-select>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="editBreed">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="closeBreed()">取消</el-button>
            </div>
        </el-dialog>
        <!--品名修改弹框 END -->

        <!-- 设置小数点位数 -->
        <el-dialog  v-dialog-drag title="小数点设置" :visible.sync="decimalShow" :before-close="decimalCancel" width="350px" class="eldialog" :model="false" custom-class="full_dialog">
            <div style="padding: 20px;">
                <el-slider class="decimalSlider" v-model="decimalNum" :step="1" :mix="0" :max="4" show-stops input-size="size" :marks="decimalMarks"></el-slider>
                <div class="decimalMarks">注：请拖动选择保留几位小数</div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="decimalSave">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="decimalCancel">取消</el-button>
            </div>
        </el-dialog>
        <!-- 删除调货数据提 -->
        <el-dialog v-dialog-drag title="提示" :visible.sync="transferOrderDialog" width="380px" class="eldialog cDiaC" :model="false">
            <el-checkbox v-model="tran_action "
                         class="confirmCheckBox">勾选同步删除调货在途资源？
            </el-checkbox>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="deleteTransfer">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="transferOrderDialog=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import bus from "../eventBus";
    import selectDownCustomer from './selectDownCustomer.vue';
    import feeRelationSale from './feeRelationSale.vue';
    import relativeFile from './downloadRelativeFile.vue';
    const initDetailItem = {
        isSelect:1,
        id: "",
        contract_no: "",
        original_bale: "",
        warehouse: "",
        storage_location: "",
        opening_company: "",
        inventory_id: "",
        bale_no: "",
        supplier: "",
        brand: "",
        breed: "",
        pay_status: "",
        sales_length: "",
        sales_width_total: "",
        sales_cube: "",
        sales_price: "",
        width: [],
        min_price: "",
        min_cube: ""
    };
    const initDetailList = [initDetailItem];
    const initTableTotal = {
        sales_amount: 0.00,
        discount_amount: 0.00,
        tax_amount: 0.00,
        traffic_amount: 0.00,
        other_amount: 0.00,
        reduce_amount: 0.00,
        receivable_amount: 0.00,
        tax_rec_amount: 0.00,
    };
    const initFormParams = {
        id: "",
        account_id: "",
        first_amount: "",
        rec_type: 1,//0 × , 1 ÷
        tax_rate: "",
        sales_time: new Date().getTime(),
        delivery_time: new Date().getTime(),
        predict_time: new Date().getTime(),
        salesman_id: localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
        customer_id: "",
        payment_type_id: "",
        remark: "",
        is_request_review: "",
        bank_no: "",
        account_name: "",
        bank_name: "",
        inventory_list: [],
        isEdit: localStorage.dw_erp_power_code.includes(",sell-order-edit,"),
        order_sn: "",
        rec: false,
        order_lock_level_id: "",
        is_show_traffic: true,
        traffic_amount: "",
        tax_rec_amount: "",
        is_discount_rate: false,
        discount_rate: "",
        reduce_amount: 0,
        other_amount: 0,
        relate_list: [],
        related_remark: ""
    };
    const initRecParams = {
    id: "",
    remark: "",
    rec:"", 
    tax_rate:"",
    rec_type:1,
    recTax_amount:"",
    };
    export default {
        created() {
            this.getInitEditSelectList();
            this.getDiscountSet();
            
        },
        data() {
            return {
                ceshiValue:{
                    name:''
                },
                dialogVisible: this.dialog,
                dialogType: this.dt,
                detailInfo: this.formData,
                columnScene: this.scene,
                sourceFrom: this.source,
                saleOrderIsEdit: true,
                recIsEdit:false,
                listDetail: this.$cloneJson(initDetailList),
                tableTotal: this.$cloneJson(initTableTotal),
                // form_params: this.$cloneJson(initFormParams),
                form_params:{
                    id: "",
                    account_id: "",
                    first_amount: "",
                    rec_type: 1,//0 × , 1 ÷
                    tax_rate: "",
                    sales_time: new Date().getTime(),
                    delivery_time: new Date().getTime(),
                    predict_time: new Date().getTime(),
                    salesman_id: localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
                    customer_id: "",
                    payment_type_id: "",
                    remark: "",
                    is_request_review: "",
                    bank_no: "",
                    account_name: "",
                    bank_name: "",
                    inventory_list: [],
                    isEdit: localStorage.dw_erp_power_code.includes(",sell-order-edit,"),
                    order_sn: "",
                    rec: false,
                    order_lock_level_id: "",
                    is_show_traffic: true,
                    traffic_amount: "",
                    tax_rec_amount: "",
                    is_discount_rate: false,
                    discount_rate: "",
                    reduce_amount: 0,
                    other_amount: 0,
                    relate_list: [],
                    related_remark: "",
                    sales_breed_id:''
                },
                filterDialogVisible: false,
                discountSet: 0,
                saleorderA: {
                    customer_id: [{required: true, message: '请填写客户名称', trigger: 'blur'}],
                    payment_type_id: [{required: true, message: '请填写付款方式', trigger: 'blur'}],
                    order_lock_level_id: [{
                        required: localStorage.dw_erp_enable_config.includes('LOCK_LEVEL'),
                        message: '请填写锁货等级',
                        trigger: 'blur'
                    }]
                },
                saleorderB: {
                    account_id: [{required: true, message: '请填写收款账户', trigger: 'blur'}]
                },
                selectMap: {
                    user: [],
                    paymentType: [],
                    account: [],
                    lockLevel: [],
                    saleBreed:[
                        {id:7,name:'红胡桃木'},
                        {id:2,name:'销售松木'},
                        {id:1,name:'销售榆木'}
                    ],
                },
                enableConfig: localStorage.dw_erp_enable_config,
                module: localStorage.dw_erp_power_code,
                billColumns: [],
                filter: [],
                filters: [],
                bill: {},
                dialogVisibleStock: false,
                dialogVisibleCustomer: false,
                dialogVisibleWidth: false,
                widthList: [],
                widthSaleInventoryId: "",
                dialogVisibleRelation: false,
                downLoadFileDialog: false,
                downFilesList: [],
                mutil_params: {
                    sales_price: "",
                    sales_cube_rate: "",//批量立方率
                    discount_price: ""
                },
                mutilDialogVisible: {
                    sales_price: false,
                    sales_cube: false,
                    discount_price: false
                },
                recChanges:false,
                rec_params: this.$cloneJson(initRecParams),
                f_rec:'',
                rec: "",
                isTipa:0,
                isTipb:0,
                isTypea:0,
                selectionDetailRow:[],
                isChange:0,
                breedChanges:false,
                sales_breedData:'',
                sales_breed:'',
                sales_breed_id:'',

                // 立方小数点
                decimalShow:false,
                decimalNum:Number(localStorage.getItem('dm_erp_decimal_scale')),
                decimalMarks:{
                    0:'0',
                    1:'0.1',
                    2:'0.01',
                    3:'0.001',
                    4:'0.0001',
                },
                transferOrderDialog:false,//删除调货提示框
                tran_action: true,//（0否 1是）
                transferId:'',
                transferData:{},
                cube_id:1,
            };
        },
        methods: {
            // 立方小数点确认
            decimalSave(){
                let {decimalNum} = this.$data;
                this.postFunc("/erp/system.set.config",{key:"DECIMAL_CUBE_SCALE",value:decimalNum,status:1},res=>{
                    this.tip('设置成功',"success")
                    this.decimalShow = false;

                    // 设置缓存
                    localStorage.setItem('dm_erp_decimal_scale',decimalNum);
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            decimalCancel(){
                this.decimalShow = false;
            },
            decimalGet(){
                this.postFunc("/erp/system.get.config",{key:"DECIMAL_CUBE_SCALE"},res=>{
                    this.decimalNum = res.data.data.value==''?4:Number(res.data.data.value);

                    // 设置缓存
                    localStorage.setItem('dm_erp_decimal_scale',this.decimalNum);
                },error=>{
                    
                })
            },

            stopstop(){},
            // 查看销售单预览
            linkSeeReview(){
                // window.open("/saleOrderSee")
                if(this.isChange==1){
                    this.tip('销售单有修改，请保存后预览',"warning")
                }else{
                    sessionStorage.removeItem("DEMU_ERP_ORDERSEE_ID");
                    sessionStorage.setItem("DEMU_ERP_ORDERSEE_ID",this.form_params.id);
                    this.$root.$children[0].$children[0].addTab({
                        name: '销售单预览'+this.form_params.id,
                        label: '销售单预览',
                        content: 'saleOrderSee'
                    });
                }
            },
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.columnScene).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            checkSelectable(row){
                return true;
                // if(row.isSelect==1){
                // }else{
                //     return false;
                // }
            },
            getInitEditSelectList() {
                for (let tar in this.selectMap) {
                    if (this.selectMap.hasOwnProperty(tar)) {
                        this.getSelectList(tar, true);
                    }
                }
            },
            getDialogTitle() {
                let title = '销售单';
                if (this.sourceFrom === 'review') {
                    title = '销售审核单';
                }else if (this.sourceFrom === 'return') {
                    title = '退货单';
                }
                if (this.dialogType > 1) {
                    title += `(单号:${this.form_params.order_sn})`;
                }
                return title;
            },
            getDiscountSet() {
                this.postFunc("/erp/system.get.config",{key:"SALE_DISCOUNT"},res=>{
                    this.discountSet = res.data.data.status;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectList(target,e){
                if(!e)return;
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            widthsaleChange(res){
                // 厚度长度拼接
                if(res.sales_width.length>1){
                    let newLength = res.sales_width.map(a=>{
                        return a.length
                    })
                    this.listDetail[this.listType].sales_length = String(newLength);
                    let newThickness = res.sales_width.map(a=>{
                        return a.thickness
                    })
                    this.listDetail[this.listType].sales_thickness = String(newThickness);
                }
                //层数 
                let layer_numberArr = res.sales_width.map(a=>{
                    return Number(a.layer_number)
                })
                let newlayer_number = layer_numberArr.reduce(function(a, b){
                    if(b){
                        return a + b; 
                    }else{
                        return a
                    }
                }, 0); 
                //片数
                let piecesArr = res.sales_width.map(a=>{
                    return Number(a.pieces)
                })
                let newpieces = piecesArr.reduce(function(a, b){
                    if(b){
                        return a + b; 
                    }else{
                        return a
                    }
                }, 0); 
                this.listDetail[this.listType].layer_number=newlayer_number;//层数
                this.listDetail[this.listType].pieces=newpieces;//片数
                this.listDetail[this.listType].sales_width=res.sales_width;
                this.listDetail[this.listType].sales_cube=res.sales_cube;
                this.listDetail[this.listType].sales_width_total=res.sales_width_total;
            },
            filterConfirm(){
                this.getBillColumn();
            },
            getBillColumn(callback = null) {
                this.filters = [];
                this.postFunc("/erp/company.column.data", {scene: this.columnScene}, response => {
                    this.billColumns = response.data.data.fields;
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                    typeof callback === "function" && callback(response.data.data);
                }, error => {
                    this.tip(error.data.message, "warning");
                })
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    sales_amount: 2,//金额
                    original_cube: 4,//码单立方
                    check_cube:4,//检尺立方
                    sales_cube:4,
                    min_amount:2,//最低额
                    // pledge_number:0,
                },total=>{
                });
            },
            saleChange(){
                this.form_params.customer_id="";
            },
            selectAccount(val){
                this.selectMap.account.forEach(item=>{
                    if(item.id==val){
                        this.form_params.bank_no=item.bank_no;
                        this.form_params.account_name=item.account_name;
                        this.form_params.bank_name=item.bank_name;
                    }
                })
            },
            getBillMess(id){
                this.postFunc("/erp/customer.detail",{id:id},response=>{
                    this.bill=response.data.data;
                    this.$emit("bill", this.bill);
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            dialogVisibleClose(){
                if(!this.form_params.id){
                    this.confirmLog("是否确定关闭?",()=>{
                        this.dialogVisible = false;
                    });
                }else{
                    this.dialogVisible = false;
                }
            },

            confirmRelative(){
                this.form_params.relate_list = this.relationObj.relate_list;
                this.form_params.related_remark = this.relationObj.related_remark;
                this.form_params.remark = this.relationObj.related_remark;
                this.form_params.traffic_amount = this.relationObj.total;
                this.tableTotal.traffic_amount = this.relationObj.total;
                this.tableTotal.tax_rec_amount = this.relationObj.tax_rec_amount;
                this.calculationTableTotal();
            },
            getRelationReceivable(){
                this.dialogVisibleRelation = true;
                this.form_params.relate_list = this.$cloneJson(this.form_params.relate_list);
            },
            relativeFileOpen(files){
                this.downLoadFileDialog = true;
                this.downFilesList = files;
            },
            withdraw(){
                this.listDetail.forEach((item)=>{
                    item.sales_cube = item.original_cube;
                    item.sales_amount = this.keepPrices(this.$bc_mul(item.sales_cube, item.sales_price));
                });
            },
            recoverCube(){
                let checkData = this.$cloneJson(this.selectionDetailRow).map(item=>(item.inventory_id));
                let dl = this.$cloneJson(this.listDetail);
                dl.forEach((item,index) => {
                    if(checkData.indexOf(item.inventory_id) == -1 ){
                        return
                    }
                    if(this.cube_id==2){//码单立方
                        item.sales_cube =  item.old_original_cube;

                    }else if(this.cube_id==3){//检尺立方
                        item.sales_cube = item.old_check_cube;
                    }else{
                        item.sales_cube = item.sales_cube_copy_reback;
                    }
                    item.sales_amount = this.keepPrices(this.$bc_mul(item.sales_cube, item.sales_price));
                });
                this.listDetail = dl;
                this.hideSalesCubeDialog();
            },
            recoverCubes(){
                let checkData = this.$cloneJson(this.selectionDetailRow).map(item=>(item.inventory_id));
                let dl = this.$cloneJson(this.listDetail);
                dl.forEach((item,index) => {
                    if(checkData.indexOf(item.inventory_id) == -1 ){
                        return
                    }
                    if(this.cube_id==2){//码单立方
                        item.sales_cube =  item.old_original_cube;

                    }else if(this.cube_id==3){//检尺立方
                        item.sales_cube = item.old_check_cube;
                    }else{
                        item.sales_cube = item.sales_cube_copy_reback;
                    }
                    item.sales_amount = this.keepPrices(this.$bc_mul(item.sales_cube, item.sales_price));
                });
                this.listDetail = dl;
            },
            //修改单价
            batchChange(){
                let sp = Number(this.mutil_params.sales_price);
                if (sp <= 0) {
                    this.tip("输入单价必须>0", 'warning');
                    return;
                }
                let message = "";
                let checkData = this.$cloneJson(this.selectionDetailRow).map(item=>(item.inventory_id));
                let dl = this.$cloneJson(this.listDetail);
                dl.forEach((item,index) => {
                    if(checkData.indexOf(item.inventory_id) == -1 ){
                        return
                    }
                    item.sales_price = sp;
                    item.sales_amount = this.keepPrices(this.$bc_mul(item.sales_cube, item.sales_price));
                    if (Number(item.sales_price) < Number(item.min_price)) {
                        message += `捆包号：${item.bale_no},单价${item.sales_price}低于最低值${item.min_price}`;
                        if (index < dl.length - 1) {
                            message += "<br/><br/>";
                        }
                    }
                });
                if(this.module.indexOf('setting-advanced-sales-mini') != -1){
                     if(message){
                         this.tip(message, "warning");
                     }
                }else{
                    if(message){
                        this.tip(message, "warning");return;
                    }
                }
                this.isTipa = 1;
                this.isTypea = 1;
                this.listDetail = dl;
                this.isChange=1;
                this.hideSalesPriceDialog();
            },
            listDetailDelete(index,row){
                if(row.is_transfer==1){
                    let obj = {};
                    obj.transferId = row.inventory_id;
                    obj.row = row;
                    obj.index = index;
                    this.transferData = obj;
                    this.transferOrderDialog = true;
                }else{
                    this.listDetail.splice(index, 1);
                    if(this.listDetail.length<=0){
                        this.listDetail = this.$cloneJson(initDetailList);
                    }
                }
            },
            //删除调货确认
            deleteTransfer(){
                this.listDetail.splice(this.transferData.index, 1);
                if(this.listDetail.length<=0){
                    this.listDetail = this.$cloneJson(initDetailList);
                }
                this.transferOrderDialog = false;
            },
            //选择库存信息
            selectData(row){
                let rowData = this.$cloneJson(row);
                rowData.forEach(item=>{
                    item.sales_cube_copy = item.sales_cube;
                    item.sales_cube_copy_reback = item.sales_cube;
                    item.discount_price = item.sales_price;
                    item.discount_price_copy = item.sales_price;
                })
                this.listDetailSet(rowData);
            },
            selectAndOut(row){
                this.selectData(row);
                this.dialogVisibleStock = false;
            },
            calculation(formNumber){
                let total = "";
                // this.pl(this.listDetail[formNumber].sales_width)
                this.listDetail[formNumber].sales_width.forEach((item,index)=>{
                    total += !!item.width&&item.width.length>0?item.width.reduce((prev,next)=> Number(prev)+Number(next)):""
                    total += !!item.width&&item.width.length>0&&index<this.listDetail[formNumber].width.length-1?"/":"";
                })
                this.listDetail[formNumber].sales_width_total = total;
                let cal_cube = 0;
                let thickness = this.listDetail[formNumber].sales_thickness.split("/");
                let length = this.listDetail[formNumber].sales_length.split("/");
                let widthT = this.listDetail[formNumber].sales_width_total.split("/");
                widthT.forEach((item,index)=>{
                    cal_cube += (Number(thickness[index])/100)*length[index]*(Number(widthT[index])/100)
                })
                this.listDetail[formNumber].sales_cube = this.keepLimit(cal_cube);
            },
            listDetailSet(row){
                if(row.length<1){
                    return;
                }
                let rows = this.$cloneJson(row);
                rows.forEach(item=>{
                    item.inventory_id=item.id;
                    item.id="";
                    if(item.inventory_cloud_id){
                        item.supplier = item.company_name;
                    }
                    item.sales_amount = this.keepPrices(this.$bc_mul(item.sales_cube, item.sales_price));
                })
                if(this.listDetail.length===1){
                    if(!this.listDetail[0].id&&!this.listDetail[0].inventory_id){
                        this.listDetail=rows;
                        return;
                    }
                }
                this.listDetail = this.listDetail.concat(rows);
                let result = [];
                let obj = {};
                let data = this.$cloneJson(this.listDetail);
                for(let i =0; i<data.length; i++){
                    if(!obj[data[i].inventory_id]){
                        result.push(data[i]);
                        obj[data[i].inventory_id] = true;
                    }
                }
                this.listDetail = result;
            },
            getRow(row){
                this.selectRow=row;
                // this.total_select=this.keepLimit(this.$bc_add(...this.selectRow.map(a=>a.sales_cube)));
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            tableRowClassName({row}) {
                for(let i=0;i<this.selectionDetailRow.length;i++){
                    if(this.selectionDetailRow[i].inventory_id){
                        if(this.selectionDetailRow[i].inventory_id==row.inventory_id){
                            return 'selectRow';
                        }
                    }
                }
                return '';
            },
            toggleSelection(row) {
                // if(row.isSelect==1){
                    this.$refs.listDetailTable.toggleRowSelection(row);
                // }else{
                //     return false;
                // }
            },
            salesCubeRateInput(e) {
                let method = '$digitInput';
                if (e.type === 'blur') {
                    method = '$digitBlur';
                }
                this.mutil_params.sales_cube_rate = e.target.value = this[method](e.target.value, 4);
            },
            salesPriceInput(e) {
                let method = '$digitInput';
                if (e.type === 'blur') {
                    method = '$digitBlur';
                }
                this.mutil_params.sales_price = e.target.value = this[method](e.target.value, 2);
            },
            salesPrice(){
                this.isChange = 1;
                this.isTipa = 0;
                this.isTypea = 1;
            },
            salesCube(){
                this.isChange = 1;
                this.isTipb = 0;
                this.isTypea = 2;
            },
            //打开修改品名弹框
            openBreed(){
                if(this.selectionDetailRow.length<1){
                    this.tip("请选择订单","warning")
                    return
                }
                this.breedChanges = true;
            },
            closeBreed(){
                this.sales_breed = '';
                this.sales_breed_id = '';
                this.sales_breedData = '';
                this.breedChanges = false;
            },
            //选后拆分id/name
            changeBreedSplit(){
                var index=this.sales_breedData.lastIndexOf("\+");
                this.sales_breed_id=this.sales_breedData.substring(0,index);
                this.sales_breed=this.sales_breedData.substring(index+1,this.sales_breedData.length);
                this.sales_breedData = this.sales_breed;
            },
            editBreed(){
                if (this.sales_breed_id <= 0) {
                    this.tip("请选择销售品名", 'warning');
                    return;
                }
                let checkData = this.$cloneJson(this.selectionDetailRow).map(item=>(item.inventory_id));
                let dl = this.$cloneJson(this.listDetail);
                dl.forEach((item,index) => {
                    if(checkData.indexOf(item.inventory_id) == -1 ){
                        return
                    }
                    item.sales_breed = this.sales_breed;
                    item.sales_breed_id  = this.sales_breed_id;
                });
                this.listDetail = dl;
                this.form_params.details = dl;
                this.closeBreed();
            },
            salesCubeChange(){
                this.recoverCubes();
                let sc = Number(this.mutil_params.sales_cube_rate);
                // if (sc <= 0) {
                //     this.tip("输入立方比率必须>0", 'warning');
                //     return;
                // }
                let message = "";
                let checkData = this.$cloneJson(this.selectionDetailRow).map(item=>(item.inventory_id));
                let dl = this.$cloneJson(this.listDetail);
                dl.forEach((item,index) => {
                    if(checkData.indexOf(item.inventory_id) == -1 ){
                        return
                    }
                    if(this.cube_id==2){//码单立方
                        item.sales_cube = sc?this.keepLimitNum(this.$bc_mul(sc, item.original_cube)):item.original_cube;

                    }else if(this.cube_id==3){//检尺立方
                        item.sales_cube =sc?this.keepLimitNum(this.$bc_mul(sc, item.check_cube)):item.check_cube;
                    }else{
                        item.sales_cube =sc?this.keepLimitNum(this.$bc_mul(sc, item.sales_cube)):item.sales_cube;
                    }
                    item.sales_amount = this.keepPrices(this.$bc_mul(item.sales_cube, item.sales_price));
                    // if (Number(item.sales_cube) < Number(item.min_cube)) {
                    //     message += `捆包号：${item.bale_no},立方数${item.sales_cube}低于最低值${item.min_cube}`;
                    //     if (index < dl.length - 1) {
                    //         message += "<br/><br/>";
                    //     }
                    // }
                });
                if(this.module.indexOf('setting-advanced-sales-mini') != -1){
                    if(message){
                        this.tip(message, "warning");
                    }
                }else{
                    if(message){
                        this.tip(message, "warning");
                        return;
                    }
                }
                this.isTipb = 1;
                this.isTypea = 2;
                this.listDetail = dl;
                this.isChange = 1;
                this.hideSalesCubeDialog();
            },
            hideSalesCubeDialog(){
                this.mutilDialogVisible.sales_cube=false;
                this.$refs['sales_cubeDialog'][0].doClose();
                this.$refs.listDetailTable.doLayout();
                this.mutil_params.sales_cube_rate = '';
                document.getElementById('ceshidom').value = '';
                // this.$nextTick(() => {
                //     for (let i = 0; i < this.listDetail.length; i++) {
                //         this.$refs.listDetailTable.toggleRowSelection(
                //         this.listDetail[i],
                //         true
                //         );
                //     }
                // });
            },
            hideSalesPriceDialog(){
                this.mutilDialogVisible.sales_price=false;
                this.$refs['sales_priceDialog'][0].doClose();
                this.$refs.listDetailTable.doLayout();
                // this.$nextTick(() => {
                //     for (let i = 0; i < this.listDetail.length; i++) {
                //         this.$refs.listDetailTable.toggleRowSelection(
                //         this.listDetail[i],
                //         true
                //         );
                //     }
                // });
            },
            //修改税金
            amend(){
                this.calcTaxAmount();
                this.recChanges = !this.recChanges;
                this.f_rec = this.rec;
                this.rec_params.id = this.form_params.id;
                this.rec_params.rec_type = this.form_params.rec_type;
                this.rec_params.tax_rate = this.form_params.tax_rate;
            },
            settlementConfirm(){
                if(this.rec_params.rec_type==1){
                    this.rec_params.rec_type ='MUL'
                }else{
                    this.rec_params.rec_type ='DIV'
                }
                if(this.f_rec==true){
                    this.f_rec=1
                }else{
                    this.f_rec=0
                }
                this.rec_params.rec = this.f_rec
                this.postFuncLoading('erp/finance.update',this.rec_params,()=>{
                    this.outRecChanges();
                    this.tip("修改成功", "success");
                    // this.dialogVisible = false;
                    let params = {name:"order_sn",id:this.form_params.id};
                    this.$emit('retrunDetail',params)
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            outRecChanges(){
                this.rec_params.remark =''
                this.recChanges = false;
            },
            //计算合计
            calculationTableTotal(){
                let sales_amount = 0;//销售金额
                let discount_amount = 0;//折扣金额
                let tax_amount = 0;//税金 （2种计算方式）this.form_params.rec_type
                let traffic_amount = 0;//关联应收费用 （运费等+）
                let tax_rec_amount = 0;//参与税金计算的关联应收费用。
                let other_amount = 0;//其他费用
                let reduce_amount = 0;//优惠金额
                let receivable_amount = 0;//应收金额
                //销售金额
                sales_amount = this.keepPrices(this.$bc_add(...this.listDetail.map(a => a.sales_amount))); 
                //折扣金额
                if (Number(this.form_params.is_discount_rate) === 1) {
                    let discount_rate = Number(this.form_params.discount_rate);
                    if (discount_rate > 0) {
                        discount_amount = this.keepPrice(this.$bc_mul(sales_amount, this.$bc_sub(1, discount_rate)));
                    }
                }
                //关联费用
                if (Number(this.form_params.traffic_amount)) {
                    traffic_amount = this.keepPrice(Number(this.form_params.traffic_amount));
                }
                //计算税金
                if (Number(this.form_params.rec) === 1) {
                    if(this.tableTotal.tax_rec_amount) tax_rec_amount = Number(this.tableTotal.tax_rec_amount);
                    let taxBase = this.$bc_add(sales_amount, -discount_amount, tax_rec_amount);
                    let tax_rate = Number(this.form_params.tax_rate);
                    let tax_rate_real = this.$bc_div(tax_rate, 100);//税率
                    if (Number(this.form_params.rec_type) === 2) {
                        //除法计算方式
                        tax_amount = this.$bc_sub(this.$bc_div(taxBase, this.$bc_sub(1, tax_rate_real)),taxBase);
                    }else{
                        //乘法计算方式
                        tax_amount = this.$bc_mul(taxBase, tax_rate_real);
                    }
                    tax_amount = this.keepPrices(tax_amount);
                }
                //其他费用
                if(Number(this.form_params.other_amount)){
                    other_amount = this.keepPrice(Number(this.form_params.other_amount));
                }
                //优惠金额
                if(Number(this.form_params.reduce_amount)){
                    reduce_amount = this.keepPrices(Number(this.form_params.reduce_amount));
                }
                //应收金额
                
                receivable_amount = this.keepPrices(this.$bc_add(sales_amount, traffic_amount, tax_amount,
                    other_amount, -discount_amount, -reduce_amount));
                this.tableTotal.receivable_amount = receivable_amount;
                this.tableTotal.sales_amount = sales_amount;
                this.tableTotal.discount_amount = discount_amount;
                this.tableTotal.tax_amount = tax_amount;
                this.tableTotal.traffic_amount = traffic_amount;
                this.tableTotal.other_amount = other_amount;
                this.tableTotal.reduce_amount = reduce_amount;
            },
            calcTaxAmount(){
                let sales_amount = 0;//销售金额
                let discount_amount = 0;//折扣金额
                let tax_rec_amount = 0;//参与税金计算的关联应收费用。
                let tax_amount = 0;//税金 （2种计算方式）this.form_params.rec_type
                //销售金额
                sales_amount = this.keepPrices(this.$bc_add(...this.listDetail.map(a => a.sales_amount)));
                //折扣金额
                if (Number(this.form_params.is_discount_rate) === 1) {
                    let discount_rate = Number(this.form_params.discount_rate);
                    if (discount_rate > 0) {
                        discount_amount = this.keepPrices(this.$bc_mul(sales_amount, this.$bc_sub(1, discount_rate)));
                    }
                }
                 //计算税金
                    if(this.tableTotal.tax_rec_amount) tax_rec_amount = Number(this.tableTotal.tax_rec_amount);
                    let taxBase = this.$bc_add(sales_amount, -discount_amount, tax_rec_amount);
                    let tax_rate = Number(this.rec_params.tax_rate);
                    let tax_rate_real = this.$bc_div(tax_rate, 100);//税率
                    if (Number(this.rec_params.rec_type) === 2) {
                        //除法计算方式
                        tax_amount = this.$bc_sub(this.$bc_div(taxBase, this.$bc_sub(1, tax_rate_real)),taxBase);
                    }else{
                        //乘法计算方式
                        tax_amount = this.$bc_mul(taxBase, tax_rate_real);
                    }
                    this.rec_params.recTax_amount = this.keepPrices(tax_amount);
            },
            selectAndOutCustomer(row){
                this.form_params.customer_id=row[0].id;
                this.dialogVisibleCustomer = !this.dialogVisibleCustomer;
            },
            changeTruck_remark(){
                if(this.form_params.id&&!this.form_params.saleOrderIsEdit){
                    this.postFunc('erp/order.update.truck',{id:this.form_params.id,truck_remark:this.form_params.truck_remark},res=>{
                         this.tip('车牌添加成功',"success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            salesWatch(){
                if (this.saleOrderIsEdit) {
                        this.listDetail.map(a => {
                            if(this.isTipa == 0 && this.isTypea == 1){
                                if(this.form_params.rec==false){
                                    if (Number(a.sales_price) < Number(a.norec_min_price)) {
                                        this.tip(`捆包号：${a.bale_no},单价${a.sales_price}不能低于最小值`, 'warning');
                                    }
                                }
                                else if(this.form_params.rec==true){
                                    if (Number(a.sales_price) < Number(a.rec_min_price)) {
                                        this.tip(`捆包号：${a.bale_no},单价${a.sales_price}不能低于最小值`, 'warning');
                                    }
                                }
                            }
                            if(this.isTipb ==0 && this.isTypea == 2){
                                if (Number(a.sales_cube) < Number(a.min_cube)) {
                                    this.tip(`捆包号：${a.bale_no},立方数${a.sales_cube}不能低于最小值`, 'warning');
                                }
                            }
                        });                
                    }
                },
        },
        props: {
            dialog: Boolean,
            dt: Number,
            formData: Object,
            scene: String,
            source:String
        },
        components: {
            selectDownCustomer,
            feeRelationSale,
            relativeFile
        },
        computed: {
            moneyTitle: function () {
                return this.sourceFrom === 'return' ? '应付' : '应收';
            }
        },
        watch: {
            dialog:function (val) {
                this.dialogVisible = val;
            },
            dt: function (val) {
                this.dialogType = val;
                this.saleOrderIsEdit = this.dialogType === 1 || this.form_params.saleOrderIsEdit;
                this.recIsEdit = this.form_params.recIsEdit;
            },
            scene: {
                immediate:true,
                handler: function (val) {
                    this.columnScene = val;
                    if (val) {
                        this.getBillColumn((data)=>{
                            this.$emit("sceneEnd",data);
                        });
                    }
                }
            },
            source: function (val) {
                this.sourceFrom = val;
            },
            formData: {
                immediate: true,
                deep:true,
                handler:function (val) {
                    if (Object.keys(val).length > 0) {
                        this.form_params = val;
                        this.saleOrderIsEdit = this.dialogType === 1 || this.form_params.saleOrderIsEdit;
                        this.recIsEdit =this.form_params.recIsEdit;
                        this.form_params = this.$changeTimeRes(this.form_params, ['sales_time', 'predict_time', 'delivery_time']);
                        this.form_params.rec = !!this.form_params.rec;
                        this.rec = this.form_params.rec;
                        this.form_params.is_show_traffic = !!this.form_params.is_show_traffic;
                        this.form_params.is_discount_rate = !!this.form_params.is_discount_rate;
                        this.tableTotal = this.$copyEditForm(initTableTotal, this.form_params);
                        this.form_params.details.forEach(item => {
                            item.sales_cube_copy = item.sales_cube;
                            item.sales_cube_copy_reback = item.old_sales_cube;
                            item.discount_price_copy = item.discount_price;
                            if (!item.sales_amount) {
                                item.sales_amount = this.keepPrices(this.$bc_mul(item.sales_cube, item.sales_price));
                            }
                        });
                        let account_info = this.form_params.account_info;
                        
                        this.form_params.bank_name = account_info.bank_name;
                        this.form_params.account_name = account_info.account_name;
                        this.form_params.bank_no = account_info.bank_no;
                        this.listDetail = this.$cloneJson(this.form_params.details);
                        // this.$nextTick(() => {
                        //     for (let i = 0; i < this.listDetail.length; i++) {
                        //         this.$refs.listDetailTable.toggleRowSelection(
                        //         this.listDetail[i],
                        //         true
                        //         );
                        //     }
                        // });
                        this.isChange=0;
                        this.selectAccount(this.form_params.account_id);
                        this.getBillMess(this.form_params.customer_id);
                    }
                }
            },
            "dialogVisible":function(val){
                if(!val){
                    // this.form_params = this.$cloneJson(initFormParams);
                    this.form_params={
                        id: "",
                        account_id: "",
                        first_amount: "",
                        rec_type: 1,//0 × , 1 ÷
                        tax_rate: "",
                        sales_time: new Date().getTime(),
                        delivery_time: new Date().getTime(),
                        predict_time: new Date().getTime(),
                        salesman_id: localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
                        customer_id: "",
                        payment_type_id: "",
                        remark: "",
                        is_request_review: "",
                        bank_no: "",
                        account_name: "",
                        bank_name: "",
                        inventory_list: [],
                        isEdit: localStorage.dw_erp_power_code.includes(",sell-order-edit,"),
                        order_sn: "",
                        rec: false,
                        order_lock_level_id: "",
                        is_show_traffic: true,
                        traffic_amount: "",
                        tax_rec_amount: "",
                        is_discount_rate: false,
                        discount_rate: "",
                        reduce_amount: 0,
                        other_amount: 0,
                        relate_list: [],
                        related_remark: ""
                    };
                    this.listDetail = this.$cloneJson(initDetailList);
                    this.tableTotal = this.$cloneJson(initTableTotal);
                    this.$refs['selectdowncustomer'].clearData();
                    this.$emit("hide");
                    this.cube_id = 1;
                } else {
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });
                }
            },
            "form_params.rec": function () {
                this.calculationTableTotal();
            },
            "form_params.rec_type": function () {
                this.calculationTableTotal();
            },
            "form_params.tax_rate": function () {
                this.calculationTableTotal();
            },
            "form_params.reduce_amount":function () {
                this.calculationTableTotal();
            },
            "form_params.traffic_amount": function () {
                this.calculationTableTotal();
            },
            "form_params.is_discount_rate": function () {
                this.calculationTableTotal();
            },
            "form_params.customer_id":function(val){
                if(val){
                    this.getBillMess(this.form_params.customer_id);
                }
            },
            "form_params.discount_rate":function (val) {
                if (val > 1 || val < 0) {
                    this.tip("折扣率必须在0-1之间", "warning");
                    this.form_params.discount_rate = '0.0';
                }
                this.calculationTableTotal();
            },
            "f_rec": function () {
            this.calcTaxAmount();
            },
            "rec_params.rec_type": function () {
            this.calcTaxAmount();
            },
            "rec_params.tax_rate": function () {
            this.calcTaxAmount();
            },
            listDetail: {
                immediate: true,
                deep: true,
                handler: function () {
                    if (this.saleOrderIsEdit) {
                        this.listDetail.map(a => {
                            a.sales_cube=="" || !a.sales_cube?0:a.sales_cube;
                            a.sales_price=="" || !a.sales_price?0:a.sales_price;
                            a.sales_amount = isNaN(this.keepPrices(this.$bc_mul(a.sales_cube, a.sales_price)))?'':this.keepPrices(this.$bc_mul(a.sales_cube, a.sales_price));
                        });                
                        this.calculationTableTotal();
                    }
                }
            },
            "dialogVisibleStock":function(val){
                if(val){
                    this.$nextTick(()=>{
                        this.$refs['selectstock'].resetSelect();
                    })
                }
            },
            "decimalShow":function(val){
                if(val){
                    this.decimalGet();
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
    .saleBaseBox /deep/ .el-input__inner{
        height: unset !important;
    }
    .REC_FORM_ITEM /deep/ .el-form-item__content{
        position: relative;
    }
    .taxDiv /deep/ {
        .taxCheck{
            z-index: 11;
        }
        .taxTypeSelect{
            width: 40px;
            position: absolute;
            left: 20px;
            top: 1px;
            z-index: 9;
            .el-input__inner{
                padding-right: 0;
                padding-left: 5px;
                font-size: 14px;
                border-right: none;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
            .el-select__caret{
                font-size: 10px;
                position: relative;
                left: 10px;
            }
        }
        .taxInput{
            position: absolute;
            top: 1px;
            padding-left: 60px;
            .el-input__inner{
                padding-left: 10px;
                padding-right: 15px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
        .taxSpan{
            position: absolute;
            right: 3px;
            top: 1px;
            color: red;
        }
    }
    .confirmCheckBox /deep/ .el-checkbox__label{
        display: inline-block;
        width: 320px;
        white-space: pre-wrap;
        text-align: left;
    }
    .cDiaC /deep/ .confirmSpan{
        text-align: left;
        display: block;
    }
    .cDiaC /deep/ .el-dialog__body{
        padding: 20px;
    }
    .cDiaC /deep/ .dialogBtnList{
        padding: 20px 10px 0 10px;
    }
    .cDiaC /deep/ .dialogBtnList .funcPublicBtn,.cDiaC /deep/ .dialogBtnList .publicBtn{
        line-height: 25px;
        padding: 0 10px;
        width: 80px;
    }
    .cDiaC /deep/ .el-dialog__header{
        text-align: left;
    }
    .cDiaC /deep/ .el-dialog__header .el-dialog__title{
        font-size: 15px;
        font-weight: unset;
    }
    .el-icon-more{position: absolute;right:0;cursor: pointer;top:2px;}

    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .bottom_flex{padding-right: 12px; padding-bottom: 8px;}
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .cDiaC /deep/ .confirmSpan{
        text-align: left;
        display: block;
    }
    .sign{width:15px;height:15px;background: url('/icon/lu.png') no-repeat 100% 100%;background-size: 100% 100%;float: right;position: relative;top:4px;}
    .form_edits{width:20px;position: absolute;left: 20px;}
    .decimalMarks{color: #777;text-align:left;margin-top: 25px;font-size: 13px;}
    .decimalSlider /deep/ .el-slider__marks .el-slider__marks-text{width: 50px;font-size: 12px;}
    .decimalSlider /deep/ .el-slider__bar{background-color:#b21111;}
    .decimalSlider /deep/ .el-slider__button{border-color: #b21111;}
    .saleSel {width:220px}
    .saleSel /deep/ .batchInput{line-height: 25px;padding: 0 10px;}
</style>